import { POI } from '../config/cameraConfig'

export interface CameraSettings {
  cameraConstraints: {
    distance: {
      min: number
      max: number
      default: number
    }
    polarAngle: {
      min: number
      max: number
      default: number
    }
    azimuthAngle: {
      min: number | null
      max: number | null
      default: number
    }
    pan: {
      x: { min: number; max: number }
      y: { min: number; max: number }
      z: { min: number; max: number }
    }
    target: {
      x: { min: number; max: number }
      y: { min: number; max: number }
      z: { min: number; max: number }
    }
  }
  mouseControls: {
    buttons: {
      rotate: number
      pan: number
      zoom: string
    }
    sensitivity: {
      rotate: number
      pan: number
      zoom: number
    }
    damping: {
      enabled: boolean
      factor: number
    }
    zoomBehavior: {
      scaleFactor: number
      towardCursor: boolean
    }
  }
  transitionSettings: {
    duration: {
      min: number
      default: number
      max: number
    }
    easing: string
  }
}

export const poiService = {
  async fetchPOIs(): Promise<POI[]> {
    try {
      const response = await fetch('/data/pois.json')
      if (!response.ok) {
        throw new Error(`Failed to fetch POIs: ${response.statusText}`)
      }
      const data = await response.json()
      return data.pois
    } catch (error) {
      console.error('Error fetching POIs:', error)
      throw error
    }
  },

  async fetchPOI(id: string): Promise<POI> {
    const pois = await this.fetchPOIs()
    const poi = pois.find((p) => p.id === id)
    if (!poi) throw new Error(`POI ${id} not found`)
    return poi
  },

  async updatePOI(_id: string, _data: Partial<POI>): Promise<POI> {
    console.log('[poiService] Save disabled in static mode')
    return _data as POI
  },

  async createPOI(data: Omit<POI, 'id'> & { id?: string }): Promise<POI> {
    console.log('[poiService] Save disabled in static mode')
    return data as POI
  },

  async deletePOI(_id: string): Promise<void> {
    console.log('[poiService] Save disabled in static mode')
  },

  async fetchCameraSettings(): Promise<CameraSettings> {
    try {
      const response = await fetch('/data/camera-settings.json')
      if (!response.ok) {
        throw new Error(`Failed to fetch camera settings: ${response.statusText}`)
      }
      return await response.json()
    } catch (error) {
      console.error('Error fetching camera settings:', error)
      throw error
    }
  },

  async updateCameraSettings(_data: CameraSettings): Promise<CameraSettings> {
    console.log('[poiService] Save disabled in static mode')
    return _data
  },

  async healthCheck(): Promise<boolean> {
    return true
  },
}
